import { i as z, x as v } from "./lit-element-8JrrHldg.js";
import { L as $ } from "./chunk.WLV3FVBR-BO0XtQ7O.js";
import { c as E } from "./chunk.TUVJKY7S-CZwfrQkU.js";
import { a as i, S, b as B, _ as k } from "./chunk.UYAO2JRR-CUGf3xdB.js";
import { a as _, o as C, f as A, s as R, b as w, c as F, p as b, t as O, d as j } from "./composed-offset-position.browser.min-CQcKT3MK.js";
import { e as P } from "./class-map-Di-Oe7s4.js";
import { n as r } from "./property-4FoNj0Pi.js";
import { e as x } from "./query-C42EGI_8.js";
var L = z`
  :host {
    --arrow-color: var(--sl-color-neutral-1000);
    --arrow-size: 6px;

    /*
     * These properties are computed to account for the arrow's dimensions after being rotated 45º. The constant
     * 0.7071 is derived from sin(45), which is the diagonal size of the arrow's container after rotating.
     */
    --arrow-size-diagonal: calc(var(--arrow-size) * 0.7071);
    --arrow-padding-offset: calc(var(--arrow-size-diagonal) - var(--arrow-size));

    display: contents;
  }

  .popup {
    position: absolute;
    isolation: isolate;
    max-width: var(--auto-size-available-width, none);
    max-height: var(--auto-size-available-height, none);
  }

  .popup--fixed {
    position: fixed;
  }

  .popup:not(.popup--active) {
    display: none;
  }

  .popup__arrow {
    position: absolute;
    width: calc(var(--arrow-size-diagonal) * 2);
    height: calc(var(--arrow-size-diagonal) * 2);
    rotate: 45deg;
    background: var(--arrow-color);
    z-index: -1;
  }

  /* Hover bridge */
  .popup-hover-bridge:not(.popup-hover-bridge--visible) {
    display: none;
  }

  .popup-hover-bridge {
    position: fixed;
    z-index: calc(var(--sl-z-index-dropdown) - 1);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    clip-path: polygon(
      var(--hover-bridge-top-left-x, 0) var(--hover-bridge-top-left-y, 0),
      var(--hover-bridge-top-right-x, 0) var(--hover-bridge-top-right-y, 0),
      var(--hover-bridge-bottom-right-x, 0) var(--hover-bridge-bottom-right-y, 0),
      var(--hover-bridge-bottom-left-x, 0) var(--hover-bridge-bottom-left-y, 0)
    );
  }
`;
function N(t) {
  return t !== null && typeof t == "object" && "getBoundingClientRect" in t && ("contextElement" in t ? t instanceof Element : !0);
}
var e = class extends S {
  constructor() {
    super(...arguments), this.localize = new $(this), this.active = !1, this.placement = "top", this.strategy = "absolute", this.distance = 0, this.skidding = 0, this.arrow = !1, this.arrowPlacement = "anchor", this.arrowPadding = 10, this.flip = !1, this.flipFallbackPlacements = "", this.flipFallbackStrategy = "best-fit", this.flipPadding = 0, this.shift = !1, this.shiftPadding = 0, this.autoSizePadding = 0, this.hoverBridge = !1, this.updateHoverBridge = () => {
      if (this.hoverBridge && this.anchorEl) {
        const t = this.anchorEl.getBoundingClientRect(), o = this.popup.getBoundingClientRect(), l = this.placement.includes("top") || this.placement.includes("bottom");
        let a = 0, h = 0, d = 0, n = 0, f = 0, s = 0, p = 0, c = 0;
        l ? t.top < o.top ? (a = t.left, h = t.bottom, d = t.right, n = t.bottom, f = o.left, s = o.top, p = o.right, c = o.top) : (a = o.left, h = o.bottom, d = o.right, n = o.bottom, f = t.left, s = t.top, p = t.right, c = t.top) : t.left < o.left ? (a = t.right, h = t.top, d = o.left, n = o.top, f = t.right, s = t.bottom, p = o.left, c = o.bottom) : (a = o.right, h = o.top, d = t.left, n = t.top, f = o.right, s = o.bottom, p = t.left, c = t.bottom), this.style.setProperty("--hover-bridge-top-left-x", `${a}px`), this.style.setProperty("--hover-bridge-top-left-y", `${h}px`), this.style.setProperty("--hover-bridge-top-right-x", `${d}px`), this.style.setProperty("--hover-bridge-top-right-y", `${n}px`), this.style.setProperty("--hover-bridge-bottom-left-x", `${f}px`), this.style.setProperty("--hover-bridge-bottom-left-y", `${s}px`), this.style.setProperty("--hover-bridge-bottom-right-x", `${p}px`), this.style.setProperty("--hover-bridge-bottom-right-y", `${c}px`);
      }
    };
  }
  async connectedCallback() {
    super.connectedCallback(), await this.updateComplete, this.start();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.stop();
  }
  async updated(t) {
    super.updated(t), t.has("active") && (this.active ? this.start() : this.stop()), t.has("anchor") && this.handleAnchorChange(), this.active && (await this.updateComplete, this.reposition());
  }
  async handleAnchorChange() {
    if (await this.stop(), this.anchor && typeof this.anchor == "string") {
      const t = this.getRootNode();
      this.anchorEl = t.getElementById(this.anchor);
    } else
      this.anchor instanceof Element || N(this.anchor) ? this.anchorEl = this.anchor : this.anchorEl = this.querySelector('[slot="anchor"]');
    this.anchorEl instanceof HTMLSlotElement && (this.anchorEl = this.anchorEl.assignedElements({ flatten: !0 })[0]), this.anchorEl && this.active && this.start();
  }
  start() {
    this.anchorEl && (this.cleanup = _(this.anchorEl, this.popup, () => {
      this.reposition();
    }));
  }
  async stop() {
    return new Promise((t) => {
      this.cleanup ? (this.cleanup(), this.cleanup = void 0, this.removeAttribute("data-current-placement"), this.style.removeProperty("--auto-size-available-width"), this.style.removeProperty("--auto-size-available-height"), requestAnimationFrame(() => t())) : t();
    });
  }
  /** Forces the popup to recalculate and reposition itself. */
  reposition() {
    if (!this.active || !this.anchorEl)
      return;
    const t = [
      // The offset middleware goes first
      C({ mainAxis: this.distance, crossAxis: this.skidding })
    ];
    this.sync ? t.push(
      w({
        apply: ({ rects: l }) => {
          const a = this.sync === "width" || this.sync === "both", h = this.sync === "height" || this.sync === "both";
          this.popup.style.width = a ? `${l.reference.width}px` : "", this.popup.style.height = h ? `${l.reference.height}px` : "";
        }
      })
    ) : (this.popup.style.width = "", this.popup.style.height = ""), this.flip && t.push(
      A({
        boundary: this.flipBoundary,
        // @ts-expect-error - We're converting a string attribute to an array here
        fallbackPlacements: this.flipFallbackPlacements,
        fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
        padding: this.flipPadding
      })
    ), this.shift && t.push(
      R({
        boundary: this.shiftBoundary,
        padding: this.shiftPadding
      })
    ), this.autoSize ? t.push(
      w({
        boundary: this.autoSizeBoundary,
        padding: this.autoSizePadding,
        apply: ({ availableWidth: l, availableHeight: a }) => {
          this.autoSize === "vertical" || this.autoSize === "both" ? this.style.setProperty("--auto-size-available-height", `${a}px`) : this.style.removeProperty("--auto-size-available-height"), this.autoSize === "horizontal" || this.autoSize === "both" ? this.style.setProperty("--auto-size-available-width", `${l}px`) : this.style.removeProperty("--auto-size-available-width");
        }
      })
    ) : (this.style.removeProperty("--auto-size-available-width"), this.style.removeProperty("--auto-size-available-height")), this.arrow && t.push(
      F({
        element: this.arrowEl,
        padding: this.arrowPadding
      })
    );
    const o = this.strategy === "absolute" ? (l) => b.getOffsetParent(l, O) : b.getOffsetParent;
    j(this.anchorEl, this.popup, {
      placement: this.placement,
      middleware: t,
      strategy: this.strategy,
      platform: B(k({}, b), {
        getOffsetParent: o
      })
    }).then(({ x: l, y: a, middlewareData: h, placement: d }) => {
      const n = this.localize.dir() === "rtl", f = { top: "bottom", right: "left", bottom: "top", left: "right" }[d.split("-")[0]];
      if (this.setAttribute("data-current-placement", d), Object.assign(this.popup.style, {
        left: `${l}px`,
        top: `${a}px`
      }), this.arrow) {
        const s = h.arrow.x, p = h.arrow.y;
        let c = "", y = "", m = "", u = "";
        if (this.arrowPlacement === "start") {
          const g = typeof s == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          c = typeof p == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "", y = n ? g : "", u = n ? "" : g;
        } else if (this.arrowPlacement === "end") {
          const g = typeof s == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          y = n ? "" : g, u = n ? g : "", m = typeof p == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
        } else
          this.arrowPlacement === "center" ? (u = typeof s == "number" ? "calc(50% - var(--arrow-size-diagonal))" : "", c = typeof p == "number" ? "calc(50% - var(--arrow-size-diagonal))" : "") : (u = typeof s == "number" ? `${s}px` : "", c = typeof p == "number" ? `${p}px` : "");
        Object.assign(this.arrowEl.style, {
          top: c,
          right: y,
          bottom: m,
          left: u,
          [f]: "calc(var(--arrow-size-diagonal) * -1)"
        });
      }
    }), requestAnimationFrame(() => this.updateHoverBridge()), this.emit("sl-reposition");
  }
  render() {
    return v`
      <slot name="anchor" @slotchange=${this.handleAnchorChange}></slot>

      <span
        part="hover-bridge"
        class=${P({
      "popup-hover-bridge": !0,
      "popup-hover-bridge--visible": this.hoverBridge && this.active
    })}
      ></span>

      <div
        part="popup"
        class=${P({
      popup: !0,
      "popup--active": this.active,
      "popup--fixed": this.strategy === "fixed",
      "popup--has-arrow": this.arrow
    })}
      >
        <slot></slot>
        ${this.arrow ? v`<div part="arrow" class="popup__arrow" role="presentation"></div>` : ""}
      </div>
    `;
  }
};
e.styles = [E, L];
i([
  x(".popup")
], e.prototype, "popup", 2);
i([
  x(".popup__arrow")
], e.prototype, "arrowEl", 2);
i([
  r()
], e.prototype, "anchor", 2);
i([
  r({ type: Boolean, reflect: !0 })
], e.prototype, "active", 2);
i([
  r({ reflect: !0 })
], e.prototype, "placement", 2);
i([
  r({ reflect: !0 })
], e.prototype, "strategy", 2);
i([
  r({ type: Number })
], e.prototype, "distance", 2);
i([
  r({ type: Number })
], e.prototype, "skidding", 2);
i([
  r({ type: Boolean })
], e.prototype, "arrow", 2);
i([
  r({ attribute: "arrow-placement" })
], e.prototype, "arrowPlacement", 2);
i([
  r({ attribute: "arrow-padding", type: Number })
], e.prototype, "arrowPadding", 2);
i([
  r({ type: Boolean })
], e.prototype, "flip", 2);
i([
  r({
    attribute: "flip-fallback-placements",
    converter: {
      fromAttribute: (t) => t.split(" ").map((o) => o.trim()).filter((o) => o !== ""),
      toAttribute: (t) => t.join(" ")
    }
  })
], e.prototype, "flipFallbackPlacements", 2);
i([
  r({ attribute: "flip-fallback-strategy" })
], e.prototype, "flipFallbackStrategy", 2);
i([
  r({ type: Object })
], e.prototype, "flipBoundary", 2);
i([
  r({ attribute: "flip-padding", type: Number })
], e.prototype, "flipPadding", 2);
i([
  r({ type: Boolean })
], e.prototype, "shift", 2);
i([
  r({ type: Object })
], e.prototype, "shiftBoundary", 2);
i([
  r({ attribute: "shift-padding", type: Number })
], e.prototype, "shiftPadding", 2);
i([
  r({ attribute: "auto-size" })
], e.prototype, "autoSize", 2);
i([
  r()
], e.prototype, "sync", 2);
i([
  r({ type: Object })
], e.prototype, "autoSizeBoundary", 2);
i([
  r({ attribute: "auto-size-padding", type: Number })
], e.prototype, "autoSizePadding", 2);
i([
  r({ attribute: "hover-bridge", type: Boolean })
], e.prototype, "hoverBridge", 2);
export {
  e as S
};
